// extracted by mini-css-extract-plugin
export default {"div":"NovoGeradorPdf_div__a7YDZ","button":"NovoGeradorPdf_button__VW5VH","iframe":"NovoGeradorPdf_iframe__5yvU1"};